import React, { Component } from 'react';

class Contact extends Component {

   recordMessage(data){
	   console.log (this.refs.contactEmail);
	   console.log (this.refs.contactName);
	   console.log (this.refs.contactSubject);
	   console.log (this.refs.contactMessage);
   }

  render() {

    if(this.props.data){
      var name = this.props.data.name;
      var street = this.props.data.address.street;
      var city = this.props.data.address.city;
      var state = this.props.data.address.state;
      var zip = this.props.data.address.zip;
      var phone= this.props.data.phone;
      var email = this.props.data.email;
      var message = this.props.data.contactmessage;
    }

    return (
      <section id="contact">

         <div className="row section-head">
            <div className="two columns header-col">
               <h1><span>Get In Touch.</span></h1>
            </div>

            <div className="ten columns">
                <p className="lead">{message}</p>
               <div className="widget widget_contact">
				   <h4>Address and Account </h4>
				   <p className="address">
					   {name}<br />
					   {street} <br />
					   {city}, {state} {zip}<br />
					   <span>{phone}</span><br />
					<a href="mailto:{email}">mailbox</a>
				   </p>
			   </div>
            </div>
         </div>
   </section>
    );
  }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/Components/Contact.js